/**
 * MatchShell — layout wrapper for the /match section.
 *
 * Wraps AppShell and adds a sticky sub-nav (Home / Quick Entry / Accounts)
 * below the main header. All match pages use this as their root.
 */
import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';
import { AppShell } from '../ui/AppShell';

const matchTabClass = ({ isActive }: { isActive: boolean }): string =>
  [
    'inline-flex items-center whitespace-nowrap rounded-md px-3 py-1.5 text-small font-medium transition-colors min-h-[36px]',
    isActive
      ? 'bg-brand-light text-brand'
      : 'text-ink-muted hover:bg-surface-raised hover:text-ink',
  ].join(' ');

function MatchSubNav() {
  return (
    <div className="sticky top-14 z-20 border-b border-border bg-surface/95 backdrop-blur-sm">
      <div className="mx-auto flex max-w-7xl items-center gap-1 overflow-x-auto px-4 py-2 sm:px-6">
        <NavLink to="/match" end className={matchTabClass}>
          Home
        </NavLink>
        <NavLink to="/match/entry" className={matchTabClass}>
          Quick Entry
        </NavLink>
        <NavLink to="/match/accounts" className={matchTabClass}>
          Accounts
        </NavLink>
      </div>
    </div>
  );
}

export function MatchShell({ children }: { children: ReactNode }) {
  return (
    <AppShell title="Match" toolbar={<MatchSubNav />}>
      {children}
    </AppShell>
  );
}
